import { InjectionToken } from '@angular/core';

export const CRM_EMAIL_TEMPLATES_ENABLED = new InjectionToken<boolean>('CRM_EMAIL_TEMPLATES_ENABLED', {
  providedIn: 'root',
  factory: () => false,
});

// Rich text editor configuration constants
export const DEFAULT_RICH_TEXT_PLUGINS = 'link lists';
export const DEFAULT_RICH_TEXT_TOOLBAR = [
  'dynamicContentButton | styleselect | bold italic link unlink | forecolor backcolor | alignleft aligncenter alignright | bullist numlist | removeformat',
];

// Email provider constants
export const EMAIL_PROVIDER_GMAIL = 'gmail' as const;
export const EMAIL_PROVIDER_OUTLOOK = 'outlook' as const;

// Email provider type
export type EmailProvider = typeof EMAIL_PROVIDER_GMAIL | typeof EMAIL_PROVIDER_OUTLOOK;

// Platform integration type constants for email providers
export const EMAIL_INTEGRATION_TYPE_GMAIL = 'GoogleGmail' as const;
export const EMAIL_INTEGRATION_TYPE_OUTLOOK = 'MicrosoftOutlook' as const;

// Email integration type
export type EmailIntegrationType = typeof EMAIL_INTEGRATION_TYPE_GMAIL | typeof EMAIL_INTEGRATION_TYPE_OUTLOOK;

// Inline image configuration
export const INLINE_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
export const ALLOWED_INLINE_IMAGE_MIME_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];

// Rich text editor config when inline images are enabled
export const RICH_TEXT_PLUGINS_WITH_IMAGES = 'link lists image paste';
export const RICH_TEXT_TOOLBAR_WITH_IMAGES = [
  'dynamicContentButton | styleselect | bold italic link unlink | forecolor backcolor | alignleft aligncenter alignright | bullist numlist | insertImage | removeformat',
];

